export const SET_CONFIG = 'CONFIG';
export const ADD_CHATEVENT = 'ADD_CHATEVENT';
export const UPDATE_CHATEVENT = 'UPDATE_CHATEVENT';
export const REPORT_ERROR = 'REPORT_ERROR';
export const MARK_ALL_READ = 'MARK_ALL_READ';
export const SET_REGISTRATION = 'SET_REGISTRATION';
export const CHAT_RESET = 'CHAT_RESET';
// chat session is active or ended
export const SET_SESSIONACTIVE = 'SET_SESSIONACTIVE';
// sending messages is possible
export const SET_AGENT = 'SET_AGENT';
// agent is typing something
export const SET_AGENTTYPING = 'SET_AGENTTYPING';
export const SET_CHATSTATE = 'SET_CHATSTATE';
// currently edited user message
export const SET_MESSAGEINPUT = 'SET_MESSAGEINPUT';
export const SHOW_OPTIONS = 'SHOW_OPTIONS';
export const SET_FILE_LIMITS = 'SET_FILE_LIMITS';

export const SET_PRELOADER = 'SET_PRELOADER';

export const SET_CALL_VIEW = 'SET_CALL_VIEW';
export const SET_CALL_REGISTRATION = 'SET_CALL_REGISTRATION';

export const SET_OFF_TOPIC = 'SET_OFF_TOPIC';

export const SET_MONITOR_FOR_USER_MO_LOGIN = 'SET_MONITOR_FOR_USER_MO_LOGIN';

export const SET_INPUT_MASK = 'SET_INPUT_MASK';
